<template>
    <div>
        <div class="flex justify-center"><LogoMail /></div>
        <div class="mx-auto mt-2 mb-6 w-[208px] text-center text-2xl font-medium">
            {{ t('us.register_success.title') }}
        </div>
        <div class="mb-6" v-html="t('us.register_success.content',{ email: email })">
        </div>
        <div>{{ t('us.register_success.content2') }}</div>
        <div>
            {{ t('us.register_success.content3') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import LogoMail from './LogoMail.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

defineProps({
    email: {
        type: String,
        required: true,
    },
});
</script>
